<ng-container *transloco="let t">
    <h2 mat-dialog-title>{{ t('SECURITY-TIPS-TITLE') }}</h2>

    <mat-dialog-content>
        <p class="mb-4">{{ t('SECURITY-TIPS-INTRO') }}</p>
        @for (group of groups; track group.id) {
            <h3 class="mt-6 mb-3 text-lg font-semibold">{{ t('SECURITY-TIPS-GROUP-' + group.id) }}</h3>
            <ul class="list-none p-0 m-0">
                @for (tip of group.tips; track tip) {
                    <li class="mb-4">
                        <h4 class="mb-1 font-semibold">{{ t('SECURITY-TIPS-' + tip + '-TITLE') }}</h4>
                        <p [innerHTML]="t('SECURITY-TIPS-' + tip + '-TEXT')"></p>
                    </li>
                }
            </ul>
        }
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button mat-flat-button color="primary" type="button" [mat-dialog-close]="true">
            {{ t('SECURITY-TIPS-CLOSE') }}
        </button>
    </mat-dialog-actions>
</ng-container>
